module.exports = __webpack_public_path__ + "media/newstyle/images/icon-search-purple-2e84ff4155da3236952afe35d4717db5.svg";